import { Message } from '@raysee/schema';
import { extractUrl } from '@raysee/utility';
import Image from 'next/image';
import { FC, ReactNode } from 'react';
import { DecorationText } from '../../text/DecorationText';
import { Bubble, Props, Sender } from './Bubble';

interface BubbleProps extends Props {
  onClick?: (url: string, message: Message) => void;
  officialTellerCardImageUrls?: string[];
}

export const TextBubble: FC<BubbleProps> = (props) => {
  const url = extractUrl(props.message.text);
  const fullSize = props.message.fullSize ?? props.fullSize;
  return (
    <>
      <Bubble {...props} fullSize={fullSize}>
        <div
          className={`rounded-2xl border p-3 drop-shadow ${
            props.sender ? 'bg-white' : 'bg-pink-100'
          }`}
        >
          {props.message.text.split('\n').map((text: string, index) =>
            ((text: string) => {
              if (text === '') return <br key={index} />;
              else if (text.startsWith('https') || text.startsWith('http'))
                return (
                  <div key={index}>
                    <Anker message={props.message} text={text} onClick={props.onClick}>
                      <span
                        className={`cursor-pointer whitespace-pre-line break-words text-[14px] leading-[22px] underline ${
                          props.sender ? 'text-gray-800' : 'text-black'
                        }`}
                      >
                        {text}
                      </span>
                    </Anker>
                    {props.message.text.split('\n').length !== index + 1 && <br />}
                  </div>
                );
              else
                return (
                  <Paragraph
                    key={index}
                    text={text}
                    message={props.message}
                    sender={props.sender}
                  />
                );
            })(text),
          )}
        </div>
      </Bubble>
      {props.message.imageUrl && props.role === 'user' && isOfficialTellerCard(props) ? (
        <div className="flex justify-center drop-shadow-xl">
          <Image
            src={props.message.imageUrl}
            alt={props.message.text}
            width={225}
            height={361}
            className="object-contain"
          />
        </div>
      ) : props.message.imageUrl &&
        props.role === 'user' &&
        props.message.imageUrl !== 'https://raysee.jp/ogp.png' ? (
        <div
          className={`mb-4 ml-6 mr-2 mt-2 flex ${props.sender ? 'justify-start' : 'justify-end'}`}
        >
          <Anker message={props.message} text={url} onClick={props.onClick}>
            <Image
              src={replaceImage(props.message.imageUrl)}
              alt={props.message.text}
              className="h-40 object-contain"
              width={1000}
              height={750}
            />
          </Anker>
        </div>
      ) : null}
    </>
  );
};

interface TextProps {
  message: Message;
  text: string;
  children?: ReactNode;
  sender?: Sender;
  onClick?: (url: string, message: Message) => void;
}

const Paragraph: FC<TextProps> = ({ text, sender }) => (
  <span
    className={`whitespace-pre-line text-[14px] leading-[22px] ${
      sender ? 'text-gray-800' : 'text-black'
    }`}
  >
    <DecorationText text={text} />
  </span>
);

const Anker: FC<TextProps> = ({ message, text, children, onClick }) => (
  <a
    href={!onClick && text}
    onClick={onClick ? () => onClick(text, message) : undefined}
    style={{}}
  >
    {children}
  </a>
);

const replaceImage = (imageUrl: string) =>
  imageUrl.startsWith('https://page-share.line.me/@259iwyul/global/og_image.png')
    ? 'https://firebasestorage.googleapis.com/v0/b/luminous-dev.appspot.com/o/ogp%2Fline_pgp.png?alt=media&token=e3399b66-aea3-4943-b652-86ab9775593b'
    : imageUrl;

const isOfficialTellerCard = (props: BubbleProps) => {
  if (!props.message.imageUrl || !props.officialTellerCardImageUrls?.length) return false;
  return props.officialTellerCardImageUrls.includes(props.message.imageUrl);
};
